import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Paper,
  TableRow,
  Switch,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getListofSE, updateSoRole } from "_controllers/officer";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { toastMessage } from "utils/toastMessage";
import { v4 } from "uuid";

const ServiceEngineer = () => {
  const { officers } = useSelector((state) => state.officers);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  console.log("se list", data);

  useEffect(async () => {
    await getListofSE()
      .then((d) => {
        console.log("data", d);
        let data = d?.data.map((d) => {
          return { id: v4(), ...d };
        });
        setData(data);
        setMessage(d?.message);
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage("error fetching data", "error");
      });
  }, [message]);

  const columns = useMemo(() => [
    {
      field: "SAP_ID",
      headerName: "SAP ID",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
    },
    {
      field: "role",
      headerName: "Role",
      flex: 1,
    },
    {
      field: "area",
      headerName: "Role Changed to SO",
      flex: 1,
    },
  ]);

  const handleActive = async (id, value) => {
    // const clickedColumnName = params.field;
    // if (clickedColumnName === "change") {
    //   console.log("Open modal for role change");
    // }
    console.log("object", id, value);
    await updateSoRole({ id, value })
      .then((d) => {
        console.log("data", d);
        setMessage(d?.message);
      })
      .catch((err) => {
        console.log("err", err);
        setMessage(err?.message);
        toastMessage("error fetching data", "error");
      });
  };

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                SAP ID
              </TableCell>
              <TableCell align="left" sx={{ fontWeight: "bolder" }}>
                Name
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Role
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bolder" }}>
                Role Changed to SO
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data && data?.length > 0
              ? data?.map((d) => (
                  <TableRow key={d._id}>
                    <TableCell align="left">{d?.SAP_ID}</TableCell>
                    <TableCell align="left">{d?.name}</TableCell>
                    <TableCell align="center">{d?.role}</TableCell>
                    <TableCell align="center">
                      <Switch
                        checked={d.changedToSo}
                        onChange={(event) => {
                          const newActiveValue = event.target.checked;
                          handleActive(d?._id, newActiveValue);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))
              : null}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <DataGrid
        rows={data}
        columns={columns}
        autoHeight={true}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        onRowClick={(data) => handleCellClick(data)}
        className="TableCell"
        rowsPerPageOptions={[10, 25, 50, 100]}
        sx={{ fontSize: "0.75rem" }}
      /> */}
    </>
  );
};

export default ServiceEngineer;
